/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{background-color:rgba(0,0,0,.85);width:80px;text-align:center;color:#fff}[_nghost-%COMP%]   .mat-button[_ngcontent-%COMP%]{margin-bottom:16px}.vertical-logo[_ngcontent-%COMP%]{-webkit-writing-mode:tb-rl;-ms-writing-mode:tb-rl;writing-mode:tb-rl;font-size:20px;padding:16px 0;color:#d54a35}"];
export { styles as styles };
